import { React, useState } from "react";
import BannerBreadcrumb from "../Components/BannerBreadcrumb";

const CheckLoanEligibility = () => {
    const elegibilityContent = [
        {
            head: "Choose from the Best Offers",
            des: "Apply for multiple loans in one go and discover the one that suits you."
        },
        {
            head: "Higher Chances of Approval",
            des: "Get expert assistance for quick and hassle-free loans with a higher approval rate."
        },
        {
            head: "Absolutely Free Service",
            des: "Get the lowest interest rate and expert end-to-end service at no extra cost to you!"
        }
    ]
    
        const [loanForm, setLoanForm] = useState({
            type: "Check Loan Eligibility",
            name: "",
            email: "",
            city: "",
            phone: "",
            gender: "",
            whatsapp: "",
            altWhatsapp: "",
            admit: "",
            courseYear: "",
            courseMonth: "",
            courseLevel: "",
            courseDegree: "",
            courseName: "",
            TCountry: "",
            college: ""
        });
        const [loanFormStep, setLoanFormStep] = useState(1);
        const [loanFormErrors, setLoanFormErrors] = useState({});
        const [loanFormLoading, setLoanFormLoading] = useState(false);
        const [loanFormSuccess, setLoanFormSuccess] = useState(false);
        const [loanFormError, setLoanFormError] = useState(null);
    
        const validateLoanForm = () => {
            const errors = {};
            if (!loanForm.name.trim() || !/^[a-zA-Z\s]+$/.test(loanForm.name)) {
                errors.name = "Name is required and should contain only letters and spaces.";
            }
            if (!loanForm.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(loanForm.email)) {
                errors.email = "Valid email is required.";
            }
            if (!loanForm.city.trim()) {
                errors.city = "City is required.";
            }
            if (!/^\d{10}$/.test(loanForm.phone)) {
                errors.phone = "Phone must be exactly 10 digits.";
            }
            return errors;
        };
    
        const handleLoanFormChange = (e) => {
            const { name, value } = e.target;
            if ((name === "phone" || name === "altWhatsapp") && !/^\d*$/.test(value)) return;
            if (name === "name" && value && !/^[a-zA-Z\s]*$/.test(value)) return;
            setLoanForm((prev) => ({
                ...prev,
                [name]: value
            }));
            setLoanFormErrors((prev) => ({
                ...prev,
                [name]: undefined
            }));
        };
    
        const handleLoanFormRadio = (name, value) => {
            setLoanForm((prev) => ({
                ...prev,
                [name]: value
            }));
            setLoanFormErrors((prev) => ({
                ...prev,
                [name]: undefined
            }));
        };
    
        const handleLoanFormSubmit = async (e) => {
            e.preventDefault();
            setLoanFormSuccess(false);
            setLoanFormError(null);
    
            const errors = validateLoanForm();
            setLoanFormErrors(errors);
            if (Object.keys(errors).length > 0) {
                setLoanFormLoading(false);
                return;
            }
    
            setLoanFormLoading(true);
    
            try {
                const formBody = new URLSearchParams({
                    ...loanForm,
                    altWhatsapp: loanForm.whatsapp === "No" ? loanForm.altWhatsapp : ""
                }).toString();
                await fetch("https://script.google.com/macros/s/AKfycbytFPsSA7Ob7jAQVmRXGHReCfkcWZmnCvpOLdSL7Zw3kEIvSn5YoQELdQBZOLJccA0/exec", {
                    method: "POST",
                    body: formBody,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                });
                setLoanFormSuccess(true);
                setLoanForm({
                    type: "Check Loan Eligibility",
                    name: "",
                    email: "",
                    city: "",
                    phone: "",
                    gender: "",
                    whatsapp: "",
                    altWhatsapp: "",
                    admit: "",
                    courseYear: "",
                    courseMonth: "",
                    courseLevel: "",
                    courseDegree: "",
                    courseName: "",
                    TCountry: "",
                    college: ""
                });
                setLoanFormStep(1);
            } catch (err) {
                setLoanFormError("Failed to submit. Please try again.");
            }
    
            setLoanFormLoading(false);
        };
    return (
        <>
            <BannerBreadcrumb head={"Check Loan Eligibilty"} pagename={"Check Loan Eligibilty"} />
            <div className="container">
                <div className="row">
                    <div className="col-md-6 loan-eligibility-left">
                        <h5 className="about-head">Secure the Perfect Education Loan for Studying Abroad!</h5>
                        <p className="loan-elegibility-des">25,000+ Abroad Education Loans Sanctioned! 8,000+ Crores Disbursed!</p>
                        {elegibilityContent.map((item, index) => (
                            <div className="loan-eligibility-content">
                                <h5>{item.head}</h5>
                                <p className="mb-0">{item.des}</p>
                            </div>))}
                    </div>
                    <div className="col-md-6 mt-5 mb-3">
                        <form className="loan-check-form" onSubmit={handleLoanFormSubmit}>
                                <h4>Fill in the Details Below</h4>
                                {loanFormSuccess && <div className="alert alert-success mt-2">Submitted successfully!</div>}
                                {loanFormError && <div className="alert alert-danger mt-2">{loanFormError}</div>}
                                <div className="row">
                                    {loanFormStep === 1 && (
                                        <>
                                            <div className="col-md-12 finance-head-form">
                                                <label className="form-label finance-label">Name <span>*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control finance-input"
                                                    placeholder="E.g. Priya Senger"
                                                    name="name"
                                                    value={loanForm.name}
                                                    onChange={handleLoanFormChange}
                                                    required
                                                />
                                                {loanFormErrors.name && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.name}</div>}
                                            </div>
                                            <div className="col-md-12 finance-head-form">
                                                <label className="form-label finance-label">Email <span>*</span></label>
                                                <input
                                                    type="email"
                                                    className="form-control finance-input"
                                                    placeholder="E.g. priya@doe.com"
                                                    name="email"
                                                    value={loanForm.email}
                                                    onChange={handleLoanFormChange}
                                                    required
                                                />
                                                {loanFormErrors.email && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.email}</div>}
                                            </div>
                                            <div className="col-md-12 finance-head-form">
                                                <label className="form-label finance-label">Applicant City of Residence <span>*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control finance-input"
                                                    placeholder="E.g. New Delhi"
                                                    name="city"
                                                    value={loanForm.city}
                                                    onChange={handleLoanFormChange}
                                                    required
                                                />
                                                {loanFormErrors.city && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.city}</div>}
                                            </div>
                                            <div className="col-md-12 finance-head-form">
                                                <label className="form-label finance-label">Phone <span>*</span></label>
                                                <input
                                                    type="tel"
                                                    className="form-control finance-input"
                                                    placeholder="E.g. 8888880000"
                                                    name="phone"
                                                    value={loanForm.phone}
                                                    onChange={handleLoanFormChange}
                                                    required
                                                    maxLength={10}
                                                />
                                                {loanFormErrors.phone && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.phone}</div>}
                                            </div>
                                            <div className="col-md-12 finance-head-form">
                                                <label className="form-label finance-label">Gender </label><br />
                                                <div className="d-flex">
                                                    <div className="me-3">
                                                        <input type="radio" className="form-check-input finance-radio" name="gender" value="Male"
                                                            checked={loanForm.gender === "Male"}
                                                            onChange={() => handleLoanFormRadio("gender", "Male")}
                                                        />
                                                        <label htmlFor="male" className="radio-label">Male</label>
                                                    </div>
                                                    <div className="me-3">
                                                        <input type="radio" className="form-check-input finance-radio" name="gender" value="Female"
                                                            checked={loanForm.gender === "Female"}
                                                            onChange={() => handleLoanFormRadio("gender", "Female")}
                                                        />
                                                        <label htmlFor="female" className="radio-label">Female</label>
                                                    </div>
                                                    <div className="">
                                                        <input type="radio" className="form-check-input finance-radio" name="gender" value="Other"
                                                            checked={loanForm.gender === "Other"}
                                                            onChange={() => handleLoanFormRadio("gender", "Other")}
                                                        />
                                                        <label htmlFor="other" className="radio-label">Other</label>
                                                    </div>
                                                </div>
                                                {loanFormErrors.gender && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.gender}</div>}
                                            </div>
                                            <div className="col-md-12 finance-head-form">
                                                <label className="form-label finance-label">Is the above number on Whatsapp? </label><br />
                                                <div className="d-flex">
                                                    <div className="me-3">
                                                        <input type="radio" className="form-check-input finance-radio" name="whatsapp" value="Yes"
                                                            checked={loanForm.whatsapp === "Yes"}
                                                            onChange={() => handleLoanFormRadio("whatsapp", "Yes")}
                                                        />
                                                        <label htmlFor="whatsapp-yes" className="radio-label">Yes</label>
                                                    </div>
                                                    <div className="me-3">
                                                        <input type="radio" className="form-check-input finance-radio" name="whatsapp" value="No"
                                                            checked={loanForm.whatsapp === "No"}
                                                            onChange={() => handleLoanFormRadio("whatsapp", "No")}
                                                        />
                                                        <label htmlFor="whatsapp-no" className="radio-label">No</label>
                                                    </div>
                                                </div>
                                                {loanFormErrors.whatsapp && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.whatsapp}</div>}
                                            </div>
                                            {loanForm.whatsapp === "No" && (
                                                <div className="col-md-12 finance-head-form">
                                                    <label className="form-label finance-label">Whatsapp Number </label>
                                                    <input
                                                        type="tel"
                                                        className="form-control finance-input"
                                                        placeholder="E.g. 8908098988"
                                                        name="altWhatsapp"
                                                        value={loanForm.altWhatsapp}
                                                        onChange={handleLoanFormChange}
                                                        required
                                                        maxLength={10}
                                                    />
                                                    {loanFormErrors.altWhatsapp && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.altWhatsapp}</div>}
                                                </div>
                                            )}
                                            <div className="col-md-12 finance-head-form">
                                                <label className="form-label finance-label">Do you have an Admit? </label><br />
                                                <div className="d-flex">
                                                    <div className="me-3">
                                                        <input type="radio" className="form-check-input finance-radio" name="admit" value="Yes"
                                                            checked={loanForm.admit === "Yes"}
                                                            onChange={() => handleLoanFormRadio("admit", "Yes")}
                                                        />
                                                        <label htmlFor="admit-yes" className="radio-label">Yes</label>
                                                    </div>
                                                    <div className="me-3">
                                                        <input type="radio" className="form-check-input finance-radio" name="admit" value="No"
                                                            checked={loanForm.admit === "No"}
                                                            onChange={() => handleLoanFormRadio("admit", "No")}
                                                        />
                                                        <label htmlFor="admit-no" className="radio-label">No</label>
                                                    </div>
                                                </div>
                                                {loanFormErrors.admit && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.admit}</div>}
                                            </div>
                                            <div className="col-12">
                                                <button
                                                    type="button"
                                                    className="loan-btn w-100 mt-3"
                                                    onClick={() => {
                                                        // Validate only step 1 fields
                                                        const errors = {};
                                                        if (!loanForm.name.trim() || !/^[a-zA-Z\s]+$/.test(loanForm.name)) {
                                                            errors.name = "Name is required and should contain only letters and spaces.";
                                                        }
                                                        if (!loanForm.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(loanForm.email)) {
                                                            errors.email = "Valid email is required.";
                                                        }
                                                        if (!loanForm.city.trim()) {
                                                            errors.city = "City is required.";
                                                        }
                                                        if (!/^\d{10}$/.test(loanForm.phone)) {
                                                            errors.phone = "Phone must be exactly 10 digits.";
                                                        }
                                                        setLoanFormErrors(errors);
                                                        if (Object.keys(errors).length === 0) {
                                                            setLoanFormStep(2);
                                                        }
                                                    }}
                                                >
                                                    Next
                                                </button>
                                            </div>
                                        </>
                                    )}
                                    {loanFormStep === 2 && (
                                        <>
                                            <div className="col-md-12 finance-head-form">
                                                <label className="form-label finance-label">Tentative Course Start Year  </label>
                                                <select
                                                    className="form-select finance-input"
                                                    name="courseYear"
                                                    value={loanForm.courseYear}
                                                    onChange={handleLoanFormChange}
                                                >
                                                    <option value="" disabled>Select Year</option>
                                                    <option value="2024">2024</option>
                                                    <option value="2025">2025</option>
                                                    <option value="2026">2026</option>
                                                    <option value="2027">2027</option>
                                                    <option value="2028">2028</option>
                                                </select>
                                                {loanFormErrors.courseYear && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.courseYear}</div>}
                                            </div>
                                            <div className="col-md-12 finance-head-form">
                                                <label className="form-label finance-label">Tentative Course Start Month  </label>
                                                <select
                                                    className="form-select finance-input"
                                                    name="courseMonth"
                                                    value={loanForm.courseMonth}
                                                    onChange={handleLoanFormChange}
                                                >
                                                    <option value="" disabled>Please Select</option>
                                                    <option value="January">January</option>
                                                    <option value="Febuary">Febuary</option>
                                                    <option value="March">March</option>
                                                    <option value="April">April</option>
                                                    <option value="May">May</option>
                                                    <option value="June">June</option>
                                                    <option value="July">July</option>
                                                    <option value="August">August</option>
                                                    <option value="September">September</option>
                                                    <option value="October">October</option>
                                                    <option value="November">November</option>
                                                    <option value="December">December</option>
                                                </select>
                                                {loanFormErrors.courseMonth && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.courseMonth}</div>}
                                            </div>
                                            <div className="col-md-12 finance-head-form">
                                                <label className="form-label finance-label">Target Course Level   </label>
                                                <select
                                                    className="form-select finance-input"
                                                    name="courseLevel"
                                                    value={loanForm.courseLevel}
                                                    onChange={handleLoanFormChange}
                                                >
                                                    <option value="" disabled>Please Select</option>
                                                    <option value="Masters">Masters</option>
                                                    <option value="Under Graduate">Under Graduate</option>
                                                    <option value="PG Diploma">PG Diploma</option>
                                                    <option value="UG Diploma">UG Diploma</option>
                                                    <option value="PhD">PhD</option>
                                                </select>
                                                {loanFormErrors.courseLevel && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.courseLevel}</div>}
                                            </div>
                                            <div className="col-md-12 finance-head-form">
                                                <label className="form-label finance-label">Target Course Degree </label>
                                                <select
                                                    className="form-select finance-input"
                                                    name="courseDegree"
                                                    value={loanForm.courseDegree}
                                                    onChange={handleLoanFormChange}
                                                >
                                                    <option value="" disabled>Please Select</option>
                                                    <option value="BTech">BTech</option>
                                                    <option value="MTech">MTech</option>
                                                    <option value="MBA">MBA</option>
                                                    <option value="MS">MS</option>
                                                </select>
                                                {loanFormErrors.courseDegree && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.courseDegree}</div>}
                                            </div>
                                            <div className="col-md-12 finance-head-form">
                                                <label className="form-label finance-label">Target Course Name </label>
                                                <input
                                                    type="text"
                                                    className="form-control finance-input"
                                                    placeholder="Master in Computer Science"
                                                    name="courseName"
                                                    value={loanForm.courseName}
                                                    onChange={handleLoanFormChange}
                                                />
                                                {loanFormErrors.courseName && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.courseName}</div>}
                                            </div>
                                            <div className="col-md-12 finance-head-form">
                                                <label className="form-label finance-label">Target Country </label>
                                                <select
                                                    className="form-select finance-input"
                                                    name="TCountry"
                                                    value={loanForm.TCountry}
                                                    onChange={handleLoanFormChange}
                                                >
                                                    <option value="" disabled>Please Select</option>
                                                    <option value="USA">USA</option>
                                                    <option value="Canada">Canada</option>
                                                    <option value="UK">UK</option>
                                                    <option value="Australia">Australia</option>
                                                </select>
                                                {loanFormErrors.TCountry && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.TCountry}</div>}
                                            </div>
                                            <div className="col-md-12 finance-head-form">
                                                <label className="form-label finance-label">Target College/University </label>
                                                <input
                                                    type="text"
                                                    className="form-control finance-input"
                                                    placeholder="E.g. University of Canada"
                                                    name="college"
                                                    value={loanForm.college}
                                                    onChange={handleLoanFormChange}
                                                    
                                                />
                                                {loanFormErrors.college && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.college}</div>}
                                            </div>
                                            <div className="col-12 d-flex justify-content-between">
                                                <button type="button" className="partner-btn ms-0 w-50 me-2 mt-3" onClick={() => setLoanFormStep(1)}>Back</button>
                                                <button type="submit" className="loan-btn w-50 ms-2 mt-3" disabled={loanFormLoading}>
                                                    {loanFormLoading ? "Submitting..." : "Submit"}
                                                </button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CheckLoanEligibility;